import type { ChangelogEntry } from "../types";

/**
 * VIB-2712. Brukersynlig for admin (ny rolle i Tilganger & roller og i
 * rollenedtrekket), og for den som setter opp TV-ene. Vanlige ansatte merker
 * ingenting, så punktene står under en admin-seksjon.
 */
export const SKJERMROLLE_2026_10: ChangelogEntry = {
  id: "2026-10-01-skjermrolle",
  date: "2026-10-01",
  title: "Egen rolle for TV-skjermene",
  summary:
    "Skjermene i resepsjonen kan nå logge inn med en konto som bare får se skjermvisningen, i stedet for en admin-konto.",
  sections: [
    {
      heading: "Tilganger",
      minRole: "admin",
      items: [
        {
          title: "Ny rolle «Skjerm (TV)»",
          kind: "nytt",
          body: "Rollen ser Display og ingenting annet. Den kommer ikke inn i prosjekter, tilbud, økonomi eller dokumentarkivet, og den har ikke chat. Den er laget for kontoen TV-ene står innlogget med, slik at en skjerm i et åpent rom ikke lenger trenger en admin-konto.",
        },
        {
          title: "Skjermkontoen regnes ikke som en ansatt",
          kind: "nytt",
          body: "Den dukker ikke opp under Ansatte, får ikke påminnelser om manglende timer, og påvirker ikke faktureringsgraden.",
        },
      ],
    },
  ],
};
